import React from 'react';
import { useBatchSelection } from '../contexts/BatchSelectionContext';
import { FiCheck } from 'react-icons/fi';

interface BatchCheckboxProps {
  id: string;
  disabled?: boolean;
  className?: string;
}

export const BatchCheckbox: React.FC<BatchCheckboxProps> = ({ 
  id, 
  disabled = false,
  className = ''
}) => {
  const { isSelected, clickItem } = useBatchSelection();
  
  const checked = isSelected(id);
  
  const handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    if (disabled) return;
    clickItem(id, e.shiftKey === true);
  };

  return (
    <div 
      className={`
        relative inline-flex items-center justify-center w-4 h-4 
        border rounded cursor-pointer transition-colors
        ${checked 
          ? 'bg-blue-500 border-blue-500' 
          : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600'
        }
        ${disabled 
          ? 'opacity-50 cursor-not-allowed' 
          : 'hover:border-blue-400'
        }
        ${className}
      `}
      onClick={handleClick}
      role="button"
      aria-pressed={checked}
      aria-disabled={disabled}
      tabIndex={0}
    >
      {checked && (
        <FiCheck className="w-3 h-3 text-white" />
      )}
    </div>
  );
}; 